"use strict"
var dashboard = angular.module("dashboardModule", [
	'ui.router',
	'servicesModule',
	'ngResource',
	// 'angular-rickshaw',
	// "btford.socket-io"
]);
require('./js/directive/dashboardDirective.js')(dashboard);
require('./js/directive/highChartsDirective.js')(dashboard);
require('./js/dashboardController.js')(dashboard);



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/dashboardModule/dashboardModule.js
// module id = 499
// module chunks = 0